import { observable, action, flow, makeObservable } from "mobx";
import { sendSMSCode } from "logic/src/services/auth";
import { MODEL_SWITCH, ResCode } from "logic/src/constants/request";

export class SmsCode {
  @observable count: number = 60;
  @observable waiting: boolean = false;
  interval: NodeJS.Timeout | null = null;

  public constructor() {
    makeObservable(this);
  }

  @action
  setCount(v: number) {
    this.count = v;
  }

  @action
  setWaiting(v: boolean) {
    this.waiting = v;
  }

  init() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  @flow.bound
  public *sendSmsCode(mobile: string): any {
    const res = yield sendSMSCode(mobile);
    // const res = {
    //   code: ResCode.Success,
    // };
    if (res.code === ResCode.Success) {
      this.setWaiting(true);
      this.interval = setInterval(() => {
        let newValue = this.count - 1;
        if (this.count <= 0) {
          clearInterval(this.interval!);
          this.setWaiting(false);
          newValue = 60;
        }
        this.setCount(newValue);
      }, 1000);
    } else {
      this.setWaiting(false);
      throw res;
    }
  }

  @action.bound
  public resetCode() {
    clearInterval(this.interval!);
    this.setWaiting(false);
    this.setCount(60);
  }
}
